<template>
  <div class="mit-actions-new-person pa-5">
      <v-row>
        <v-col cols="6">
          <v-card elevation="6" to="/action/new/person/steps" class="fill-height d-flex flex-column" color="blue-grey" dark>
                <v-card-title class="text-h5"><v-icon class="pr-3" x-large>mdi-account</v-icon>New Person</v-card-title>
                <v-card-subtitle class="font-weight-bold">Start adding a new CSAIL lab member or create from a request</v-card-subtitle>
                <v-spacer></v-spacer>
                <v-card-actions class="pa-4">
                  <v-btn color="blue-grey darken-3" rounded to="/action/new/person/steps">New</v-btn>
                </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="6">
          <v-card elevation="6" to="/action/continue/person" class="fill-height d-flex flex-column" color="secondary lighten-2" dark>
                <v-card-title class="text-h5"><v-icon class="pr-3" x-large>mdi-account-edit</v-icon>Continue Person</v-card-title>
                <v-card-subtitle class="font-weight-bold">Continue adding a CSAIL member that is in progress</v-card-subtitle>
                <v-spacer></v-spacer>
                <v-card-actions class="pa-4">
                  <v-btn rounded to="/action/continue/person">Continue</v-btn>
                </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
  </div>
</template>

<script>

export default {
  name: 'MitActionsNewPerson',
  components: {
  },
  props: {
  },
  data: function() {
    return {
    }
  },
  created() {

  },
  methods : {
    
  }
}
</script>

<style lang="scss" scoped>
</style>
